<template>
    <div>
        <BookingBack :isDark="true" title="After-sales Request"/>
        <van-form @submit="onSubmit" class="myForm">
            <div style="width:100%;padding:1rem 1rem 0 1rem;box-sizing: border-box;">
                <van-field
                    class="myTextarea"
                    v-model="form.content"
                    name="content"
                    rows="5"
                    autosize
                    type="textarea"
                    maxlength="200"
                    placeholder="Please enter refund reason"
                    show-word-limit
                    required
                    :rules="[{ required: true }]"
                />
            </div>
            <van-field name="images">
                <template #input>
                    <van-uploader :after-read="afterRead"  v-model="fileList" multiple :max-count="3" :max-size="5000 * 1024" @oversize="onOversize"/>
                </template>
            </van-field>
            <div class="submitBox">
                <van-button block type="info" color="#1E3C3E" native-type="submit">Submit for Review</van-button>
            </div>
        </van-form>
    </div>
</template>
<script>
import BookingBack from '@/components/Booking/back.vue'
import myMixin from '@/utils/myMixin'
import { getToken } from '@/utils/storage'
import { Toast } from 'vant'
export default {
    name:'RefundOrder',
    mixins:[myMixin],
    data(){
        return {
            fileList:[],
            form:{
                content:'',
                images:[],
                order_service_id:Number(this.$route.query.order_id)
            }
        }
    },
    components:{
        BookingBack
    },
    mounted(){
    },
    methods:{
        onSubmit(values){
            let files = []
            for( let child of values.images ){
                files.push({file_id:child.file_id,file_path:child.file_path})
            }
            this.form.images = files
            this.$api.reFundApply(this.form).then(res=>{
                if(res.code == 200){
                }else{
                    Toast(res.msg)
                }
            })
        },
        onOversize(file) {
            Toast('File size cannot exceed 5000 KB')
        },
        afterRead(file){
            file.status = 'uploading'
            file.message = 'Uploading...'
            const fd = new FormData()
            fd.append('iFile', file.file,file.file.name)
            this.$api.uploadFile(fd).then(res=>{
                if(res.code == 1){
                    // 上传完毕
                    file.status = 'done'
                    file.message = ''
                    // 设置图片地址
                    file.file_id = res.data.file_id
                    file.url = this.getUrl(res.data.file_path)
                    file.file_path = this.getUrl(res.data.file_path)
                }else{
                    file.status = 'fail'
                    file.message = ''
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .myForm{
        width: 100%;
        .myTextarea{
            background-color: #F8F8F8;
            border-radius: .5rem;
        }
    }
    .submitBox{
        width: 100%;
        position: fixed;
        bottom: 1rem;
        left: 50%;
        transform: translate(-50%);
        padding:0 1rem;
        box-sizing: border-box;
    }
</style>
